import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { ButtonComponent } from '@modules/components/button/button.component';

@Component({
  selector: 'app-sql-query-token-dialog',
  imports: [MatDialogModule, MatButtonModule, MatInputModule, MatIconModule, ButtonComponent],
  templateUrl: './sql-query-token-dialog.component.html',
  styleUrl: './sql-query-token-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SqlQueryTokenDialogComponent {
  token = inject<string>(MAT_DIALOG_DATA);

  copied = signal(false);

  copy() {
    navigator.clipboard.writeText(this.token).then(() => {
      this.copied.set(true);
      setTimeout(() => this.copied.set(false), 2000);
    });
  }
}
